import { render, staticRenderFns } from "./chinesePush.vue?vue&type=template&id=e748ff88&scoped=true"
import script from "./chinesePush.vue?vue&type=script&lang=js"
export * from "./chinesePush.vue?vue&type=script&lang=js"
import style0 from "./chinesePush.vue?vue&type=style&index=0&id=e748ff88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e748ff88",
  null
  
)

export default component.exports